import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-legal-docs',
  templateUrl: './legal-docs.component.html',
  styleUrls: ['./legal-docs.component.css']
})
export class LegalDocsComponent implements OnInit {
  data: any;
    module: string;
  constructor(private route: ActivatedRoute, private confPost: ConfService) { }

  ngOnInit() {
      this.route.queryParams
          .subscribe(params => {
             // this.module = params.module;
              this.data = null;
              this.getModule(params.doc);
          });
  }
  getModule(val) {
      this.confPost.getLegalDocs(val).subscribe(data => {
          this.data = data;
      });
  }

}
